/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-17 11:32:30
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-01 17:35:45
 */
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Modal, notification, Tabs } from 'antd'
import _ from 'lodash'
import React, {
  forwardRef,
  ReactElement,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { OutpatientAudit } from '../outpatientaudit/OutpatientAudit'
import { Inspect } from './inspect/inspect'
import styles from "./outPatientList.module.css";
import { useDispatch, useSelector } from "react-redux";
import { selectThreeMenus } from "../../layouts/layoutSlice";
import { selectEdition } from "../../app/applicationSlice";
import { SJQXChecks } from '../../models/dataPersion'
import { RootDispatch } from '../../app/store'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'

const { TabPane } = Tabs

export const RealOutPatientList = (
  props: {
    state?: any //1是从医生工作站那边过来的,2 统计分析-》门诊报表-》门诊日志
    parentId?: string
  },
  ref: any
): ReactElement => {
  const InspectRef = useRef<any>()

  const dispatch = useDispatch<RootDispatch>()

  const threeMenus = useSelector(selectThreeMenus)?.filter(
    (v: any) => v.parentId == props?.parentId
  )

  const [flag, setFlag] = useState(true)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const getKeys = (i: string) => {
    switch (i) {
      case '通用版':
        return '0'
      case '卫监第二版':
        return '1'
      default:
        return '-'
    }
  }

  useImperativeHandle(
    ref,
    () => ({
      webExport: () => {
        InspectRef.current?.webExport()
      },
      exportLoading:InspectRef.current?.exportLoading,
    }),
    [InspectRef.current]
  )

  const [currentTab, setCurrentTab] = useState('0')

  const [CKSJHQXData, setCKHRSJHData] = useState(true) // 统计分析查看患者手机号

  const [CKSFZHQXData, setCKSFZHQXData] = useState(true) // 统计分析查看患者身份证号

  // useEffect(() => {
  //   const itemCode = SJQXChecks.TJFXCKHRSJH
  //   dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
  //       .then(unwrapResult)
  //       .then((res: any) => {
  //         setCKHRSJHData(res)
  //       })
  //   dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.TJFXCKHZSFZH }))
  //       .then(unwrapResult)
  //       .then((res: any) => {
  //         setCKSFZHQXData(res)
  //       })
  // }, [])

  useEffect(() => {
    if (!flag) return
    const tab = getKeys(threeMenus[0]?.name)
    if (threeMenus?.length) {
      setCurrentTab(tab)
      setFlag(false)
    } else {
      setCurrentTab('0')
    }
  }, [props?.parentId, threeMenus])

  return (
    <>
      <Tabs
        className={styles.tabs}
        activeKey={currentTab}
        onChange={(t) => setCurrentTab(t)}
      >
        {threeMenus?.map((v: any) => {
          return (
            <>
              <TabPane key={getKeys(v?.name)} tab={v?.name}>
                {v?.name == '通用版' ? (
                  <OutpatientAudit
                    state={props?.state}
                    currentUserMode={false}
                    route={{
                      name: '',
                      path:
                        props?.state == 1
                          ? '/doctor/station' 
                          : hisVersion == 1
                          ? '/outpatientReport' 
                          : '/statistics/outpatient',
                    }}
                  />
                ) : v?.name == '卫监第二版' ? (
                  <Inspect ref={InspectRef} state={props?.state}/>
                ) : (
                  <></>
                )}
              </TabPane>
            </>
          )
        })}

        {/* <TabPane tab='通用版' key='0'>
          <OutpatientAudit
            currentUserMode={false}
            route={{
              name: '',
              path:
                props?.state == 1
                  ? '/doctor/station'
                  : '/statistics/outpatient',
            }}
          />
        </TabPane>
        <TabPane tab='卫监第二版' key='1'>
          <Inspect ref={InspectRef} />
        </TabPane> */}
      </Tabs>
      {currentTab === '1' ? (
        <>
          <Button
            loading={ref?.current?.exportLoading}
            type='primary'
            style={{
              position: 'absolute',
              top: '20px',
              right: '30px',
            }}
            onClick={() => {
              if (props?.state) {
                dispatch(getCheckPermissionAsync({ itemCode: props?.state == 1 ? SJQXChecks.YSGZZDCDYQX : props?.state == 2 ? SJQXChecks.DCDYQX : '' }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    ref.current.webExport()
                  })
              } else {
                ref.current.webExport()
              }
            }}
          >
            导出
          </Button>
          <p
            style={{
              position: 'absolute',
              top: '20px',
              right: '120px',
              lineHeight: '37px',
            }}
          >
             （最多支持导出10000条数据，更多请联系客服）
          </p>
        </>
      ) : currentTab === '0' ? (
        <p
          style={{
            position: 'absolute',
            top: '20px',
            right: '30px',
            lineHeight: '37px',
          }}
        >
           （最多支持导出10000条数据，更多请联系客服）
        </p>
      ) : (
        <></>
      )}
    </>
  )
}

export const OutPatientList = forwardRef(RealOutPatientList)
